<template>
  <div class="gradient-bg-container">
    <svg class="AnimatedGradient__animated-gradient___SSGQn">
      <defs>
        <linearGradient :id="sign" x1="0" y1="0" x2="0" y2="100%">
          <stop offset="0" stop-color="#e3fdf5">
            <animate
              attributeName="stop-color"
              values="#e3fdf5;#dfe3f3;#e6cfdc;#edf2c3;#e5fed7;#e0c3fc;#b5b4f4;
              #feada6;#fff1eb;#a8edea;#e3fdf5;"
              dur="70s"
              repeatCount="indefinite"
            ></animate>
          </stop>
          <stop offset="1" stop-color="#ffe6fa">
            <animate
              attributeName="stop-color"
              values="#ffe6fa;#fcc2c7;#ffe3de;#bce1df;#c9f9e1;#b2d5f8;#f8d0da;
              #f5efef;#ace0f9;#fed6e3;#ffe6fa;"
              dur="75s"
              repeatCount="indefinite"
            ></animate>
          </stop>
        </linearGradient>
      </defs>
      <rect width="100%" height="100%" :fill="`url(#${sign})`"></rect>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'c_animated-gradient-bg',
  props: ['sign'],
  date() {
    return {
      sh: window.innerHeight,
    };
  },
  mounted() {
    console.log(this);
  },
};
</script>

<style lang="scss" scoped>
.gradient-bg-container {
  width: 100%;
  height: 100vh;
  position: relative;
  svg {
    width: 100%;
    height: 100%;
  }
}
</style>
